import React from "react";
var __jsx = React.createElement;
import { useTranslation } from "react-i18next";
import { faPlus } from "@fortawesome/pro-regular-svg-icons";
import { Button } from "@/components/button";
/** Inline "Select patient record" button shown in a task action row when nothing is linked yet. */
export function TaskActionLinkRecords(_ref) {
  var actionId = _ref.actionId,
    onOpenLinkRecords = _ref.onOpenLinkRecords;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement(Button, {
    "data-testid": "task-action-select-patient-record-".concat(actionId),
    variant: "secondary",
    size: "sm",
    leftIcon: faPlus,
    className: "flex-1",
    onClick: onOpenLinkRecords
  }, t("label.select_patient_record", {
    defaultValue: "Select patient record"
  }));
}